/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown> }} Practice_EditInputs */



/**
* | output |
* | --- |
* | "Edit {title}" |
*
* @param {Practice_EditInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_edit = /** @type {((inputs: Practice_EditInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_EditInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Bewerk ${i?.title}`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Modifier ${i?.title}`)
	return /** @type {LocalizedString} */ (`Edit ${i?.title}`)
});